import type { SVGProps } from 'react';
const SvgIconEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M7.84 7.099a.75.75 0 0 1 0 1.06L6.074 9.927a.75.75 0 0 1-1.06-1.06L6.78 7.099a.75.75 0 0 1 1.06 0" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.381 7.276a2.5 2.5 0 0 0 0-3.536L12.26 1.619a2.5 2.5 0 0 0-3.536 0L1.91 8.434a2.5 2.5 0 0 0-.722 1.541l-.293 3.23a1.75 1.75 0 0 0 1.901 1.901l3.23-.293a2.5 2.5 0 0 0 1.541-.722zM9.785 2.679a1 1 0 0 1 1.414 0l2.122 2.122a1 1 0 0 1 0 1.414l-1.061 1.06L8.724 3.74zM7.664 4.801 2.97 9.494a1 1 0 0 0-.289.617l-.144 1.584 1.768 1.768 1.584-.144a1 1 0 0 0 .617-.289l4.693-4.694z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconEdit;
